import { Splide, SplideSlide } from "@splidejs/react-splide";

import useDeviceType from "../../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AbsoluteCenter, Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import useProcessEventList from "../../hook/useProcessEventList";
import { useMemo } from "react";
import { COMMON_WEB_PATH, DATA2_PATH } from "../../constant";
import i18next from "i18next";
import { languageMapping } from "../../i18n/config";
import useProcessCarouselList from "../../hook/useProcessCarouselList";
import dayjs from "dayjs";
import LazyImageV4 from "../Loading/lazyImage_v4";

const Carousel = () => {
  const { i18n } = useTranslation();

  const isMobile = useDeviceType() === "Mobile";
  const eventList = useSelector((state) => state.isEventList);
  const carouselList = useSelector((state) => state.isCarouselList);

  const processEventList = useProcessEventList({ event_list: eventList });
  const processCarouselList = useProcessCarouselList({
    carousel_list: carouselList,
  });
  const filter_event_list = useMemo(() => {
    return processEventList?.filter((item) => item?.is_show_carousel == 1);
  }, [processEventList]);
  return (
    <Box position="relative" p={{ base: "5px", md: 0 }}>
      <AbsoluteCenter
        w="100%"
        h="100%"
        bgImage={`${COMMON_WEB_PATH}/now888/carousel_background.png`}
        borderRadius={"10px"}
        transform={{
          base: "translate(-50%, -50%) rotate(1.5deg)",
          md: "translate(-50%, -50%) rotate(2deg)",
        }}
        top={{
          base: "52%",
          sm: "52%",
        }}
        zIndex={-1}
      ></AbsoluteCenter>
      <AbsoluteCenter
        position={"absolute"}
        w="96%"
        h="91%"
        bgImage={`${COMMON_WEB_PATH}/FlyDragon/free_background_landscape.png`}
        opacity={0.5}
        bgRepeat={`no-repeat`}
        bgSize={`100% 100%`}
      ></AbsoluteCenter>
      <Box
        bgImage={`${COMMON_WEB_PATH}/now888/carousel_border.png`}
        //p="8px"
        pr={{
          base: "4px",
          sm: "10px",
        }}
        pl={{
          base: "4px",
          sm: "10px",
        }}
        pt={{
          base: "4px",
          sm: "10px",
        }}
        pb={{
          base: "4px",
          sm: "10px",
        }}
        bgSize="100% 100%"
        bgRepeat={`no-repeat`}
        bgPos="center"
        position={"relative"}
        w="100%"
        h="100%"
        minH={{
          sm: "250px",
          base: "150px",
        }}
      >
        <Splide
          className="h-full w-full v2"
          options={{
            type: "slide",
            rewind: true,
            gap: 10,
            autoplay: true,
            arrows: false,
            breakpoints: {
              640: {
                perPage: 1,
              },
              768: {
                perPage: 1,
              },
              1024: {
                perPage: 1,
              },
              3000: {
                perPage: 1,
              },
            },
          }}
        >
          {processCarouselList?.map((item) => {
            const { uid, image_mobile, image_pc, process_url_link } =
              item || {};
            const lang = languageMapping(i18next.language);
            return (
              <SplideSlide key={uid}>
                <Link to={process_url_link}>
                  <Box
                    height={{
                      sm: "250px",
                      base: "150px",
                    }}
                    width="100%"
                    overflow="hidden"

                    // borderColor="leaderBoard.v3-border"
                  >
                    <Box
                      display={{
                        base: "block",
                        lg: "none",
                      }}
                      w="100%"
                      h="100%"
                    >
                      <LazyImageV4
                        onError={({ currentTarget }) => {
                          if (!currentTarget.dataset.errorHandled) {
                            currentTarget.dataset.errorHandled = "true";
                            currentTarget.src = `${DATA2_PATH}/carousels/${image_mobile}?${dayjs().format(
                              "YYYYMMDDHHmmss"
                            )}`;
                          }
                        }}
                        src={`${DATA2_PATH}/carousels/${image_mobile}?${dayjs().format(
                          "YYYYMMDDHHmmss"
                        )}`}
                        closeInverted
                        fetchPriority="high"
                        alt={item?.title}
                        className={`object-cover h-full !w-full`}
                      />
                    </Box>
                    <Box
                      display={{
                        base: "none",
                        lg: "block",
                      }}
                      w="100%"
                      h="100%"
                    >
                      <LazyImageV4
                        onError={({ currentTarget }) => {
                          if (!currentTarget.dataset.errorHandled) {
                            currentTarget.dataset.errorHandled = "true";
                            currentTarget.src = `${DATA2_PATH}/carousels/${image_pc}?${dayjs().format(
                              "YYYYMMDDHHmmss"
                            )}`;
                          }
                        }}
                        src={`${DATA2_PATH}/carousels/${image_pc}?${dayjs().format(
                          "YYYYMMDDHHmmss"
                        )}`}
                        closeInverted
                        fetchPriority="high"
                        alt={item?.title}
                        className={`object-cover h-full !w-full`}
                      />
                    </Box>
                  </Box>
                </Link>
              </SplideSlide>
            );
          })}
          {filter_event_list?.map((item) => {
            const { uid } = item || {};
            const lang = languageMapping(i18next.language);

            return (
              <SplideSlide key={uid}>
                <Link to={`/promotion/detail/${uid}`}>
                  <Box
                    height={{
                      sm: "29 0px",
                      base: "150px",
                    }}
                    width="100%"
                    overflow="hidden"
                    // borderColor="leaderBoard.v3-border"
                  >
                    <Box
                      display={{
                        base: "block",
                        lg: "none",
                      }}
                      w="100%"
                      h="100%"
                    >
                      <LazyImageV4
                        onError={({ currentTarget }) => {
                          if (!currentTarget.dataset.errorHandled) {
                            currentTarget.dataset.errorHandled = "true";
                            currentTarget.src = `${DATA2_PATH}/event/${uid}/en_US/${uid}_en_US_mobile_image.png?${dayjs().format(
                              "YYYYMMDDHHmmss"
                            )}`;
                          }
                        }}
                        src={`${DATA2_PATH}/event/${uid}/${lang}/${uid}_${lang}_mobile_image.png?${dayjs().format(
                          "YYYYMMDDHHmmss"
                        )}`}
                        closeInverted
                        fetchPriority="high"
                        alt={item?.title}
                        className={`object-cover !h-full !w-full object-contain`}
                      />
                    </Box>
                    <Box
                      display={{
                        base: "none",
                        lg: "block",
                      }}
                      w="100%"
                      h="100%"
                    >
                      <LazyImageV4
                        onError={({ currentTarget }) => {
                          if (!currentTarget.dataset.errorHandled) {
                            currentTarget.dataset.errorHandled = "true";
                            currentTarget.src = `${DATA2_PATH}/event/${uid}/en_US/${uid}_en_US_pc_image.png?${dayjs().format(
                              "YYYYMMDDHHmmss"
                            )}`;
                          }
                        }}
                        src={`${DATA2_PATH}/event/${uid}/${lang}/${uid}_${lang}_pc_image.png?${dayjs().format(
                          "YYYYMMDDHHmmss"
                        )}`}
                        closeInverted
                        fetchPriority="high"
                        alt={item?.title}
                        className={`object-cover !h-full !w-full object-contain shadow`}
                      />
                    </Box>
                  </Box>
                </Link>
              </SplideSlide>
            );
          })}
        </Splide>
      </Box>
    </Box>
  );
};

export default Carousel;
